module.exports = __webpack_public_path__ + "media/images/icons/twotone/wallet-59a853d44f217abd031e4bc41d8a4b14.svg";